import React, { useState } from 'react';
import ProfileImage from './ProfileImage';
import ProfileHeader from './ProfileHeader';
import Bio from './Bio';
import Skills from './Skills';
import InteractiveButtons from './InteractiveButtons';
import LikeButton from './LikeButton';
import './App.css';

function PortfolioCard() {
  const [isDark, setIsDark] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [likes, setLikes] = useState(127);
  const [isLiked, setIsLiked] = useState(false);
  
  const profile = {
    name: "Arjun Patel",
    title: "AI/ML Engineer",
    bio: "Building intelligent systems that solve real-world problems. Passionate about deep learning, computer vision, and creating AI solutions that make a difference.",
    initials: "AP",
    photos: [
      null,
      "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150",
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=150"
    ],
    skills: [
      { name: "Python", level: "expert" },
      { name: "TensorFlow", level: "expert" },
      { name: "PyTorch", level: "advanced" },
      { name: "Computer Vision", level: "advanced" },
      { name: "AWS", level: "intermediate" },
      { name: "Docker", level: "intermediate" }
    ]
  };

  const handleThemeToggle = () => {
    setIsDark(!isDark);
  };

  const handlePhotoChange = () => {
    setPhotoIndex((prev) => (prev + 1) % profile.photos.length);
  };

  const handleShowAlert = () => {
    alert(`🚀 Hey there! I'm ${profile.name}, an ${profile.title}. Let's build something amazing together!`);
  };

  const handleLike = () => {
    if (isLiked) {
      setLikes(likes - 1);
      setIsLiked(false);
    } else {
      setLikes(likes + 1);
      setIsLiked(true);
    }
  };

  return (
    <div className={`portfolio-card ${isDark ? 'dark' : ''}`}>
      <InteractiveButtons 
        onThemeToggle={handleThemeToggle}
        onPhotoChange={handlePhotoChange}
        onShowAlert={handleShowAlert}
        isDark={isDark}
      />
      
      <ProfileImage 
        src={profile.photos[photoIndex]}
        initials={profile.initials}
        alt={profile.name}
        onClick={handlePhotoChange}
      />
      
      <ProfileHeader 
        name={profile.name}
        title={profile.title}
      />
      
      <Bio text={profile.bio} />
      
      <Skills skills={profile.skills} />
      
      <LikeButton 
        likes={likes}
        isLiked={isLiked}
        onLike={handleLike}
      />
    </div>
  );
}

export default PortfolioCard;